export function getUrlString(params, keys = [], isArray = false) {
    const p = Object.keys(params)
        .map((key) => {
            const val = encodeURIComponent(params[key]);

            if (Object.prototype.toString.call(val) === "[object Object]" || Array.isArray(val)) {
                if (Array.isArray(params)) {
                    keys.push("");
                } else {
                    keys.push(key);
                }
                return getUrlString(val, keys, Array.isArray(val));
            }
            let tKey = key;

            if (keys.length > 0) {
                const tKeys = isArray ? keys : [...keys, key];
                tKey = tKeys.reduce((str, k) => (str === "" ? k : `${str}[${k}]`), "");
            }
            if (isArray) {
                return `${tKey}[]=${val}`;
            }
            return `${tKey}=${val}`;
        })
        .join("&");

    keys.pop();
    return p;
}

export function param(params, keys, isArray) {
    return getUrlString(params, keys, isArray);
}
